import { API_ROOT, config } from '../../config/config'

import { doGet, doPost, doDelete, doPut } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getInviteForm = (projectVersionId, acceptance) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/invited?acceptance=${acceptance || '0'}`
  return doGet(url)
}

export const sendInviteForm = (projectVersionId, request) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/invited`
  return doPost(url, request)
}

export const deleteInvaite = (id, projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/invited/${id}`
  return doDelete(url)
}

export const getInviteAcceptForm = (se) => {
  const url = `${config.serverIP}/redirect/project-invite/manage?se=${se}`
  // const url = `http://localhost:9002/redirect/project-invite/manage?se=${se}`
  return doGet(url)
}

export const saveInviteAcceptanceBySe = (se, request) => {
  const url = `${config.serverIP}/redirect/project-invite/manage?se=${se}`
  // const url = `http://localhost:9002/redirect/project-invite/manage?se=${se}`
  return doPost(url, request)
}

export const saveInviteAcceptanceByProjectId = (projectVersionId, request) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/project-invite/manage`
  return doPut(url, request)
}
